/* Helper function to help safeguard against localStorage being
 * restricted (user manually disabled it). Default to just setting
 * value in `window` object. This abstracts the try..catch process
 */

type LocalStorageObj = {
  get: (arg0: string) => string | null | undefined;
  set: (arg0: string, arg1: string) => void;
  remove: (arg0: string) => void;
};

const localStorage: LocalStorageObj = {
  get(key: string) {
    try {
      return window.localStorage?.getItem(key);
    } catch {
      return undefined;
    }
  },

  set(key: string, val: string) {
    try {
      if (window.localStorage) window.localStorage.setItem(key, val);
    } catch {
      // do nothing
    }
  },

  remove(key: string) {
    try {
      if (window.localStorage) window.localStorage.removeItem(key);
    } catch {
      // do nothing
    }
  },
};

export default localStorage;
